export default "__VITE_ASSET__lkZq2N18__"